import { ReduxService } from 'dashboard-services/services';

import { exportCustomInsightActions } from 'actions/modules/insight';

export const emailExportInitialState = {
  step: "",
  emailSubject: "",
  reportTitle: "",
  recipients: [],
  initDetails: {
    emailSubject: undefined,
    recipients: [],
    reportTitle: undefined
  }
}

export const emailExportReducer = (state = emailExportInitialState, action) => {
  switch (action.type) {
    case exportCustomInsightActions.ON_CHANGE_EXPORT: {
      if(state.emailExportState[action.name] !== action.value) {
        return ReduxService.updateObject(state, { emailExportState: ReduxService.updateObject(state.emailExportState, { [action.name]: action.value }) })
      }
      return state;
    }
    case exportCustomInsightActions.ON_CHANGE_EXPORT_INIT_DETAILS: {
      if(state.emailExportState.initDetails[action.name] !== action.value) {
        const modifiedInitDetails = ReduxService.updateObject(state.emailExportState.initDetails, { [action.name]: action.value }),
              modifiedEmailExportState = ReduxService.updateObject(state.emailExportState, { initDetails: modifiedInitDetails })
        return ReduxService.updateObject(state, { emailExportState: modifiedEmailExportState })
      }
      return state;
    }
    case exportCustomInsightActions.ON_CLEAR_EXPORT:
      return ReduxService.updateObject(state, { emailExportState: emailExportInitialState })
    default:
      return undefined;
  }
}